import React, { useEffect } from 'react'
import { analytics } from 'infra/analytics'
import { Seo } from 'components/common/seo'
import { HOST_BASE_URL } from 'infra/constants'
import { GreetingContents } from 'components/scouts/greeting/greeting-contents'
import { WithHeaderFooter } from 'components/misc/with-header-footer'

const Landing: React.FC = () => {
  useEffect(() => {
    analytics.traffic('scouts_new_landing')
  }, [])
  return (
    <>
      <Seo
        title='그룹바이 | 스카우트 제안받기'
        url={`${HOST_BASE_URL}/landing`}
      />
      <WithHeaderFooter>
        <GreetingContents />
      </WithHeaderFooter>
    </>
  )
}

export default Landing
